import React from 'react';
import PropTypes from "prop-types";

const FormRowError = (props) => {

    if (!props.error) {
        return null;
    }

    if (props.error instanceof Array) {
        return (<>
            {Object.keys(props.error).map(key => (
                <div key={key}>
                    <small className="error">
                        {props.error[key]}
                    </small>
                </div>
            ))}
        </>);
    }

    return (
        <div><small className="error">{props.error}</small></div>
    )
};

FormRowError.propTypes = {
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.array])
};

FormRowError.defaultProps = {
    error: '',
};

export default FormRowError;
